import { formatDate } from '../../utils/dateUtils';

export const formatEbankingJNumber = (jNumber: string | null | undefined): string => jNumber ?? '-';

export const formatEbankingBlocked = (isBlocked: boolean | null | undefined): string =>
  isBlocked === undefined ? '-' : isBlocked ? 'Yes' : 'No';

export const formatEbankingLastLogin = (lastLogin: Date | null | undefined): string =>
  formatDate(lastLogin ?? undefined);
